import Table from "components/elements/Table";
import Select from "components/elements/Select";
import {
  API_BASE,
  BILLING_STATUSES,
  BILLING_STATUSES_REVERSE,
} from "core/Constants";
import MonthInput from "components/elements/MonthInput";
import { useEffect, useState } from "react";
import dataProvider from "core/DataProvider";
import utility from "core/Utils";
import toast from "react-hot-toast";
import { ReactComponent as EditIcon } from "../../../images/edit.svg";
import { ReactComponent as DownloadIcon } from "../../../images/download.svg";
import { ReactComponent as DocumentIcon } from "../../../images/document.svg";
import { ReactComponent as ApproveIcon } from "../../../images/approve.svg";
import BillingAdjustment from "./BillingAdjustment";
import IconInput from "components/elements/IconInput";
const listingHeaders = {
  action: "Action",
  id: "ID",
  group_name: "Group Name",
  requested_from_month: "Calculated From",
  billing_month: "Billing Month",
  count: "Spots",
  final_count: "Billed spots",
  total_amount: "Billing Amount",
  status: "Status",
};

const getDefaultPeriodFrom = () => {
  let dt = new Date();
  // dt.setDate(1);
  dt.setMonth(dt.getMonth() - 1);

  let parts = dt.toISOString().split("T")[0].split("-");
  return `${parts[0]}-${parts[1]}`;
};

const getDefaultPeriodTo = () => {
  let dt = new Date();
  // dt.setDate(0);
  dt.setMonth(dt.getMonth() - 1);

  let parts = dt.toISOString().split("T")[0].split("-");
  return `${parts[0]}-${parts[1]}`;
};

const customDateFormat = date => {
  let returnDate = date;

  if (typeof returnDate === "string") {
    try {
      returnDate = new Date(returnDate);
    } catch (error) {
      console.warn(`Invalid date passed to formatDate`);
      return returnDate;
    }
  }

  try {
    returnDate = new Intl.DateTimeFormat("en-US", {
      year: "numeric",
      month: "short",
    }).format(returnDate);
  } catch (error) {
    console.warn(`Invalid date passed to formatDate`);
  }

  return returnDate;
};

const BillingListing = props => {
  const [loading, setLoading] = useState(false);
  const [periodFrom, setPeriodFrom] = useState(getDefaultPeriodFrom());
  const [periodTo, setPeriodTo] = useState(getDefaultPeriodTo());
  const [status, setStatus] = useState(
    Object.keys(BILLING_STATUSES).map(k => ({
      value: k,
      label: BILLING_STATUSES[k],
    }))
  );
  const [search, setSearch] = useState("");
  const [list, setList] = useState([]);
  const [adjustment, setAdjustment] = useState(null);
 const [selectedItems, setSelectedItems] = useState([]);

const handleCheck = (item,mon, checked) => {
    if (checked) {
      // Add in required format
      setSelectedItems(prev => [...prev, { id: item, billing_month: mon }]);
    } else {
      // Remove by id
      setSelectedItems(prev => prev.filter(i => i.id !== item));
    }
    //console.log('chk list',selectedItems);
  };
const confirm_save = async () => {
const billids = selectedItems.map(item => item.id);
  const confirmed = window.confirm("Are you sure you want to Save & Finalize bill of  "+billids+" ?");
  if (!confirmed) return;

  try {
    // Example: Simulate async save (e.g., API call)
    //await saveData();  // replace with actual async function
   // console.log("Save completed");
    setLoading(true);
       try {
  // 1. Fetch all billing details in parallel
                    const fetchRequests = selectedItems.map(item =>
                      dataProvider.network.get(
                        `billing/details/${item.id}/${utility.formatDateForInput(item.billing_month)}`
                      ).then(response => ({
                        id: item.id,
                        billing_month: item.billing_month,
                        billRows: response.data?.billRows || [],
                      }))
                    );

                    const fetchedData = await Promise.all(fetchRequests);

                    // 2. Build adjustment payloads
                    const adjustmentPayloads = fetchedData.map(item => {
                        const adjustments = item.billRows
                        .filter(x => parseInt(x.adjustment) > 0)
                        .map(x => ({
                          id: x.id,
                          adjustment: parseInt(x.adjustment),
                        }));

                       // if (adjustments.length === 0) return null;

                        return {
                          bill_id: item.id,
                          adjustments,
                        };
                      })
                      .filter(Boolean); // Remove nulls (items with no adjustments)
                      if (adjustmentPayloads.length === 0) {
                          toast("No adjustments found to save.");
                          setLoading(false);
                          return;
                        }
                    // 3. Send all adjustment payloads in parallel
                    const saveRequests = adjustmentPayloads.map(data =>
                      dataProvider.network.post("billing/save-adjustment", data)
                    );

                    await Promise.all(saveRequests);
                    toast.success("All adjustments saved successfully");
                    //props.onClose();
                    setSelectedItems([]);
                    await loadList();
                  } catch (error) {
                    console.error("One or more operations failed:", error);
                    const message =
                      error?.response?.data?.message ||
                      error?.response?.data?.error ||
                      "Failed to process adjustments";
                    toast.error(message);
                  } finally {
                    setLoading(false);
                  }

  } catch (err) {
    console.error("Error saving:", err);
  }
};

  const downloadPDF = x => {
    let url = `${API_BASE}/billing/download-pdf/${x.id}`;
    window.open(url, "_blank");
  };

  const downloadCSV = x => {
    let url = `${API_BASE}/billing/download/csv/${x.id}`;
    window.open(url, "_blank");
  };

  const loadList = async () => {
    setLoading(true);

    try {
      const data = await dataProvider.network.post("billing/listing", {
        period_from: utility.formatDateForInput(periodFrom),
        period_to: utility.formatDateForInput(periodTo),
        status: status.map(x => parseInt(x.value)),
      });

      setList(
        data.map(x => ({
          ...x,
          billing_month: customDateFormat(x.billing_month),
          requested_from_month: customDateFormat(x.requested_from_month),
          status: BILLING_STATUSES[x.status],
          total_amount :  x.status === BILLING_STATUSES_REVERSE.Generated ? '0' : x.total_amount,
          action: (
            <div className="flex">
              {x.status === BILLING_STATUSES_REVERSE.Generated ? (
                 <>
                <div
                  className="flex-center"
                  title="Adjustment"
                  onClick={() => setAdjustment(x)}
                >
                  <EditIcon title="Adjustment" style={{ width: '14px' }}/>


                </div>
 <input
    type="checkbox" checked={selectedItems.some(i => i.id === x.id)}
    onChange={e => handleCheck(x.id,x.billing_month,e.target.checked)} // prevent triggering setAdjustment
    style={{ width: '20px',marginRight:'5px' }}
  /> </>
              ) : (
                <div style={{ width: "80px" }}>
                  <div
                    className="action-button flex flex-center"
                    title="PDF Download"
                    onClick={() => downloadPDF(x)}
                  >
                    <DownloadIcon title="PDF Download" />
                  </div>

                  <div
                    className="action-button flex flex-center"
                    title="CSV Download"
                    onClick={() => downloadCSV(x)}
                  >
                    <DocumentIcon title="CSV Download" />
                  </div>
                </div>
              )}
            </div>
          ),
        }))
      );
    } catch (error) {
      console.error(error);
      toast.error("Failed to load billing listing");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadList();
    //console.log('chk list 222', selectedItems);
  }, [selectedItems]);

  return (
    <div className="billing-listing">
      {adjustment && (
        <BillingAdjustment
          data={adjustment}
          onClose={() => {
            setAdjustment(null);
            loadList();
          }}
        />
      )}
      <div className="box mtop">
        <div className="flex flex-v-center">
          <div className="el">
            <h3 className="pad-lr">Generated Bills</h3>
          </div>
          <div className="el flex flex-full">
            <div className="filter right">
              <div className="flex flex-v-center billing-filter-row">
                <div
                  className="flex flex-full"
                  style={{ justifyContent: "end" }}
                >

                  <div className="el flex" style={{ alignItems: "end" }}>
                    <MonthInput
                      value={periodFrom}
                      onChange={val => setPeriodFrom(val)}
                      placeholder="Period From"
                      customFormat={customDateFormat}
                    />
                  </div>
                  <div className="el flex" style={{ alignItems: "end" }}>
                    <MonthInput
                      value={periodTo}
                      onChange={val => setPeriodTo(val)}
                      placeholder="Period To"
                      customFormat={customDateFormat}
                    />
                  </div>
                  <div className="el flex flex-v-center">
                    <Select
                      isMulti
                      value={status}
                      options={Object.keys(BILLING_STATUSES).map(k => ({
                        value: k,
                        label: BILLING_STATUSES[k],
                      }))}
                      placeholder="Status"
                      onChange={val => setStatus(val)}
                    />
                  </div>
                  <div className="el flex" style={{ alignItems: "end" }}>
              <IconInput
                value={search}
                onChange={e => setSearch(e.target.value)}
                placeholder="Search (min 3 character)"
                icon="search"
                style={{ minWidth: "200px" }}
              />
            </div>
                </div>
                <div className="right flex pad-lr">
                  <button className="grey-button" onClick={() => loadList()}>
                    Apply Filters
                  </button>
                </div>
              </div>
              <div className="right flex">
                <div className="el">
                  {loading && (
                    <div className="loader">
                      <div className="lds-hourglass"></div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="mtop">
          {selectedItems.length > 0 && (
            <div className="flex right flex-v-center">
              <div className="spot-button " style={{marginLeft:"15px"}}>
                <button className="icon-button" onClick={() => confirm_save()}>
                Save & Finalize
                </button></div></div>
              )}
          <Table headers={listingHeaders} data={list} search={search}/>
        </div>
      </div>
    </div>
  );
};

export default BillingListing;
